import { request, authRequest } from "~/utils/api";
import { showAppMessage } from "~/redux/actions/app";

export const fetchWordingTemplatesData = (params) => {
  return request({
    url: "/wording_templates",
    params: params,
  }).then((res) => {
    const { wording_templates, pager } = res.data;
    return { wording_templates, pager };
  });
};

export const fetchWordingTemplate = (id) => {
  return request({
    url: `/wording_templates/${id}`,
  }).then((res) => {
    return res.data.wording_template;
  });
};

export const createWordingTemplate = (token, data) => {
  return authRequest(token, {
    url: "/wording_templates",
    method: "POST",
    data: data,
  }).then((res) => {
    return res.data;
  });
};

export const updateWordingTemplate = (token, id, data) => {
  return authRequest(token, {
    url: `/wording_templates/${id}`,
    method: "PUT",
    data: data,
  }).then((res) => {
    return res.data;
  });
};

export const deleteWordingTemplate = (token, id) => {
  return authRequest(token, {
    url: `/wording_templates/${id}`,
    method: "DELETE",
  }).then((res) => {
    return res.data;
  });
};

export const SET_WORDING_TEMPLATES = "SET_WORDING_TEMPLATES";
export const fetchWordingTemplates = (
  token,
  page,
  scenarios = [],
  keyword = null
) => {
  return (dispatch) => {
    const params = { page };
    if (scenarios && scenarios.length > 0) {
      params.scenarios = scenarios;
    }
    if (keyword) {
      params.keyword = keyword;
    }

    return authRequest(token, {
      url: "/wording_templates",
      params: params,
    }).then((res) => {
      dispatch({
        type: SET_WORDING_TEMPLATES,
        wordingTemplates: res.data,
      });
    });
  };
};

export const createWordingTemplateAction = (token, params, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: "/wording_templates",
      method: "POST",
      data: {
        wording_template: params,
      },
    }).then((res) => {
      dispatch(showAppMessage("创建成功", "success"));
      callback();
    });
  };
};

export const updateWordingTemplateAction = (token, params, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/wording_templates/${params.id}`,
      method: "PUT",
      data: {
        wording_template: params,
      },
    }).then((res) => {
      dispatch(showAppMessage("更新成功", "success"));
      callback();
    });
  };
};

export const deleteWordingTemplateAction = (token, id, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/wording_templates/${id}`,
      method: "DELETE",
    }).then((res) => {
      dispatch(showAppMessage("删除成功", "success"));
      callback();
    });
  };
};

export const SET_WORDING_TEMPLATE_PARAMS = "SET_WORDING_TEMPLATE_PARAMS";
export const setWordingTemplateModalParams = (wordingTemplateModalParams) => {
  return {
    type: SET_WORDING_TEMPLATE_PARAMS,
    wordingTemplateModalParams,
  };
};

export const updateWordingTemplateHeatAction = (token, id, heat, callback) => {
  return (dispatch) => {
    authRequest(token, {
      url: `/wording_templates/${id}/update_heat`,
      method: "PUT",
      data: { heat },
    })
      .then((res) => {
        dispatch(showAppMessage("使用频次更新成功", "success"));
        if (callback) {
          callback();
        }
      })
      .catch((err) => {
        dispatch(showAppMessage("使用频次更新失败", "error"));
      });
  };
};

export const WORDING_TEMPLATE_CHANGED = "WORDING_TEMPLATE_CHANGED";

export const wordingTemplateChanged = (changeType) => {
  return (dispatch) => {
    dispatch({
      type: WORDING_TEMPLATE_CHANGED,
      payload: { changeType },
    });
    setTimeout(() => {
      dispatch({
        type: WORDING_TEMPLATE_CHANGED,
        payload: { changeType: null },
      });
    }, 100);
  };
};
